import {
  AMEX_PROFESSIONAL_SIX_DOLLARS,
  AMEX_PROFESSIONAL_SIX_DOLLARS_STRIPE,
  AMEX_STARTER_FREE,
  AMEX_STARTER_FREE_STRIPE
} from '@Shared/constants';
import { PARTNER_ID_WTI_GLOBAL } from '@Shared/constants/partners';
import { ICompanyModel } from '@Shared/models';

export function isAmexCompany(company: ICompanyModel) {
  if (!company) {
    return false;
  }

  return (
    [AMEX_STARTER_FREE, AMEX_PROFESSIONAL_SIX_DOLLARS, AMEX_STARTER_FREE_STRIPE, AMEX_PROFESSIONAL_SIX_DOLLARS_STRIPE].indexOf(
      company.billing_plan
    ) !== -1
  );
}

export function getSignUpChannel(company: ICompanyModel) {
  if (isAmexCompany(company)) {
    return 'amex';
  }

  const utm_parameter = company?.utm_parameter as any;

  return utm_parameter?.referralParameters?.channel || 'direct';
}

export function isWtiSignupCompany(company: ICompanyModel) {
  return company?.partner_id === PARTNER_ID_WTI_GLOBAL || getSignUpChannel(company) === PARTNER_ID_WTI_GLOBAL;
}
